import { render } from "./ErrorBasic.vue?vue&type=template&id=c77b78fa&scoped=true"
import script from "./ErrorBasic.vue?vue&type=script&lang=js"
export * from "./ErrorBasic.vue?vue&type=script&lang=js"

import "./ErrorBasic.vue?vue&type=style&index=0&id=c77b78fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c77b78fa"]])

export default __exports__